var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"empty-tips u-flex-col u-col-center u-row-center"},[_c('van-image',{attrs:{"width":"2.6rem","height":"2.7rem","src":require('../assets/images/empty_bg.png')}}),_c('p',{staticClass:"empty-title"},[_vm._v(_vm._s(_vm.text))]),_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }